import React, { useEffect, useState } from "react";
import "./UnitProgress.scss";
import { completionCardInterface } from "../../../interfaces";
import { useSelector } from "react-redux";
import translate from "../../../i18n/translate";

const UnitProgress = (props: completionCardInterface) => {
  const allInfo = useSelector((state: any) => state);
  const [badge, setBadge] = useState("");
  // PROP TYPES:
  /*-- SPRINT BUSINESS SKILLS --
    0. Prework completed    
    1. Total sessions completed
  */  
 useEffect(()=> {
  if(!!allInfo.skillOutcomeSummary.data &&!!allInfo.skillOutcomeSummary.data.learnerOutcomeDetails && allInfo.skillOutcomeSummary.data.learnerOutcomeDetails.length > 0 && allInfo.skillOutcomeSummary.data.learnerOutcomeDetails.filter((summary : any)=>{
    return summary.skill_name===(props.cardData.skillTitle|| props.cardData.name)}).length > 0)
    {
      setBadge(allInfo.skillOutcomeSummary.data.learnerOutcomeDetails.filter((summary : any)=>{
        return summary.skill_name===(props.cardData.skillTitle|| props.cardData.name)
        })[0].skill_summary[0].badge);
    }
 },[allInfo.skillOutcomeSummary, props]);
 

  return (
    <div className="unit-overall-cover">
      {props.type === "0" && (
        <div className="indiv-overall-block">
          <div className="i-overall-title">{props.title}</div>
          {props.cardData && (
            <div className="i-overall-details">
              {Math.round((props.cardData.prework / props.cardData.totalprework) * 100)
                ? Math.round((props.cardData.prework / props.cardData.totalprework) * 100)
                : 0}{" "}
              % ({props.cardData.prework}/{props.cardData.totalprework})
            </div>
          )}
        </div>
      )}
      {props.type === "1" && (
        <div className="indiv-overall-block">
          <div className="i-overall-title">{props.title}</div>
          {props.cardData && (
            <div className="i-overall-details">
              {Math.round((props.cardData.sessions / props.cardData.totalsessions) * 100)
                ? Math.round((props.cardData.sessions / props.cardData.totalsessions) * 100)
                : 0}{" "}
              % ({props.cardData.sessions}/{props.cardData.totalsessions})
            </div>
          )}
        </div>
      )}
       {props.type === "2" && (
        <div className="indiv-overall-block">
         {!!badge && badge!=="No Badge" && <div className="i-overall-title">{translate("progress_overall_card_title_badge")}</div> }
          {props.cardData && (
            <div className="unit-badge">
              {!! badge && badge!=="No Badge" && <img className="subskill-unit-badge" src={process.env["REACT_APP_ASSETS_URL"]+"/halo/badges/businessskills/essential/" +badge.toLowerCase()+"-restaurants-and-hotels.svg"} /> }
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UnitProgress;
